export enum DIRECTORIES_ADMIN {
    /**
     * @value All directories
     */
    ALL_DIRECTORIES = 'DIRECTORIES_ADMIN.ALL_DIRECTORIES',
    /**
     * @value Users can add entries to favorites
     */
    CAN_ADD_NEW_ENTRIES = 'ADMIN_MODULE_DIRECTORY_SETTINGS_FAVORITES_HELP',
    /**
     * @value Custom fields available for entries
     */
    CUSTOM_FIELDS_AVAILABLE = 'DIRECTORIES_ADMIN.CUSTOM_FIELDS_AVAILABLE',
    /**
     * @value Delete directory?
     */
    DELETE_DIRECTORY = 'DIRECTORIES_ADMIN.DELETE_DIRECTORY',
    /**
     * @value Deleting the directory %NAME% is irreversible. You will delete the entire configuration.
     */
    DELETE_DIRECTORY_DESCRIPTION = 'DIRECTORIES_ADMIN.DELETE_DIRECTORY_DESCRIPTION',
    /**
     * @value Users in specific groups can add local entries
     */
    LOCAL_ENTRIES = 'DIRECTORIES_ADMIN.LOCAL_ENTRIES',
    /**
     * @value Metadata available for entries
     */
    METADATA_AVAILABLE = 'DIRECTORIES_ADMIN.METADATA_AVAILABLE',
    /**
     * @value New directory
     */
    NEW_DIRECTORY = 'DIRECTORIES_ADMIN.NEW_DIRECTORY',
}
